import {Injectable} from '@angular/core';
import {userIsOnboarded} from 'src/app/domain/model/user.model';
import { UserSession } from 'src/app/infrastructure/environment/user-session';

@Injectable({
  providedIn: 'root',
})

export default class HelpSupportRouteResolverService {
  static readonly onboardingSupportUrl = '/onboarding/help/support';
  static readonly customerAreaSupportUrl = '/client/help/support';
  static readonly defaultSupportUrl = '/help/support';

  public constructor(private userSession: UserSession) {
  }

  public resolveSupportUrl(): string {
    return userIsOnboarded(this.userSession.loggedUser())
      ? HelpSupportRouteResolverService.customerAreaSupportUrl
      : HelpSupportRouteResolverService.onboardingSupportUrl;
  }
}
